import { PagedResults } from "../models/generics";
import { Billing } from "../types/Billing";
import {
  RegisterStructureDTO,
  Structure,
  StructureCoach,
  UserFavorites,
} from "../types/Structure";
import client from "./axios";

const hostBaseUrl = "https://internal-api.getmoveapp.com/api/v1/admin/users";
//const hostBaseUrl = "http://localhost:8081/api/v1/admin/users";
const hostStructureBaseUrl =
 "https://internal-api.getmoveapp.com/api/v1/admin/structures";
// const hostStructureBaseUrl =
//   "http://localhost:8081/api/v1/admin/structures";
const structureBaseUrl =
  "https://internal-api.getmoveapp.com/api/v1/structures";
//const structureBaseUrl = "http://localhost:3000/api/v1/admin/structures";

export const Structures = {
  getStructureCoaches: () =>
    client.get<{ list: StructureCoach[] }>(`${hostBaseUrl}/get-coaches`),
  associateCoach: (userId: string) =>
    client.post<{ association: StructureCoach }>(
      `${hostBaseUrl}/associate-coach`,
      { userId }
    ),
  dissociateCoach: (userId: string) =>
    client.delete<{ result: string }>(
      `${hostBaseUrl}/dissociate-coach/${userId}`
    ),
  getHostFavorites: () =>
    client.get<{ list: UserFavorites[] }>(
      `${hostStructureBaseUrl}/favorites`
    ),
  getHostFavoritesPaginated: (params?: URLSearchParams) =>
    client.get<PagedResults<UserFavorites>>(
      `${hostStructureBaseUrl}/favorites/paginated`,
      {
        params,
      }
    ),
  getHostStructure: () =>
    client.get<{ structure: Structure }>(`${hostStructureBaseUrl}`),
  getStructureImageUrl: (id: string) =>
    client.get<{ url: string }>(`${structureBaseUrl}/get-image-url/${id}`),
  updateStructure: (id: string, fd: FormData) =>
    client.put(`${structureBaseUrl}/${id}`, fd),
  registerStructure: (body: RegisterStructureDTO) =>
    client.post<{ userId: string; structure: Structure; billing: Billing }>(
      `${structureBaseUrl}/register`,
      body
    ),
};
